import { configureStore } from "@reduxjs/toolkit";
import {
  authReducer,
  footballMatchCommentaryReducer,
  footballCompetitionAwardsReducer,
  footballCompetitionReducer,
  footballCompetitionStatsReducer,
  footballCompetitionTeamsReducer,
  footballManageCompetitionDeleteReducer,
  footballManageCompetitionListReducer,
  footballManageCompetitionReducer,
  footballManageCompetitionSeasonTeamAddReducer,
  footballManageCompetitionSeasonTeamListReducer,
  footballManagePlayerDeleteReducer,
  footballManagePlayerListReducer,
  footballManagePlayerReducer,
  footballManagePlayerRetireReducer,
  footballManageRefereeDeleteReducer,
  footballManageRefereeListReducer,
  footballManageSeasonAddReducer,
  footballManageSeasonEditReducer,
  footballManageSeasonEndReducer,
  footballManageTeamDeleteReducer,
  footballManageTeamListReducer,
  footballManageTeamPlayerAddEditReducer,
  footballManageTeamPlayersReducer,
  footballManageTeamReducer,
  footballManageTeamTerminateReducer,
  footballMatchDetailReducer,
  footballMatchListReducer,
  footballMatchStatsReducer,
  footballPlayerAttributeReducer,
  footballPlayerAwardReducer,
  footballPlayerPositionsReducer,
  footballPlayerReducer,
  footballPlayerStatisticsReducer,
  footballPlayerTeamsReducer,
  footballPlayerTrainingsReducer,
  footballSeasonReducer,
  footballSeasonStandingReducer,
  footballComparativeStatisticsReducer,
  footballTeamAwardReducer,
  footballTeamCompetitionsReducer,
  footballTeamDetailReducer,
  footballTeamPlayersReducer,
  footballTeamPlayersStatisticsReducer,
  footballTeamStatisticsReducer,
  footballTeamTrainingReducer,
  imageUploadReducer,
  manageStadiumDeleteReducer,
  manageStadiumListReducer,
  manageStadiumReducer,
  newsReducer,
  sessionReducer,
  pageTitleReducer,
  footballManageSeasonFixtureGroupAddReducer,
  footballManageSeasonFixtureGroupsReducer,
  footballManageSeasonFixtureGroupEditReducer,
  footballManageSeasonFixtureGroupDeleteReducer,
  footballManageSeasonFixtureGroupFixturesReducer,
  footballManageSeasonFixtureGroupFixtureAddReducer,
  footballManageSeasonFixtureGroupFixtureEditReducer,
  footballManageSeasonFixtureGroupFixtureDeleteReducer,
  footballManageSeasonMatchDetailReducer,
  footballManageSeasonMatchTeamLineupReducer,
  footballManageCompetitionSeasonTeamRemoveReducer,
  footballManageTeamPlayerRemoveReducer,
  footballManagePlayerActiveReducer,
  footballManageTeamActivateReducer,
  footballManageSeasonMatchCommentaryListReducer,
  footballManageSeasonMatchCommentaryAddReducer,
  footballManageSeasonMatchCommentaryEditReducer,
  footballManageSeasonMatchCommentaryDeleteReducer,
  footballManageSeasonMatchPossessionListReducer,
  footballManageSeasonMatchPossessionAddReducer,
  footballManageSeasonMatchPossessionEditReducer,
  footballManageSeasonMatchPossessionDeleteReducer,
  footballManageSeasonMatchPlayersStatisticListReducer,
  footballManageSeasonMatchPlayersStatisticAddReducer,
  footballManageSeasonMatchPlayersStatisticEditReducer,
  footballManageSeasonMatchPlayersStatisticDeleteReducer,
  footballManageSeasonMatchEditReducer,
  footballSeasonMatchTimeReducer,
  footballManageTeamPlayersAvailableReducer,
  footballManageCompetitionSeasonReducer,
  footballPlayerCompetitionsReducer,
  footballManageTeamCompetitionsReducer,
  footballManageCompetitionSeasonStandingReducer,
  footballManagePlayerCompetitionsReducer,
  footballManagePlayerStatisticsReducer,
  footballManageTeamStatisticsReducer,
  footballManageCompetitionSeasonStatisticsReducer,
  footballManageCompetitionSeasonMatchListReducer,
  footballPlayerMatchListReducer,
  footballManagePlayerMatchListReducer,
  footballMatchTeamsReducer,
  footballManageSeasonMatchTeamsReducer,
  manageStadiumEditReducer,
  manageStadiumAddReducer,
  footballManageRefereeEditReducer,
  footballManageRefereeAddReducer,
  footballManageCompetitionEditReducer,
  footballManageCompetitionAddReducer,
  footballManagePlayerAddReducer,
  footballManagePlayerEditReducer,
  footballManageTeamEditReducer,
  footballManageTeamAddReducer,
  toolbarSearchReducer,
  footballManageSeasonTeamGroupAddReducer,
  footballManageSeasonTeamGroupEditReducer,
  footballManageSeasonTeamGroupDeleteReducer,
  footballManageSeasonTeamGroupListReducer,
  footballManageSeasonTeamGroupTeamAddReducer,
  footballManageSeasonTeamGroupTeamRemoveReducer,
  footballSeasonStatisticsReducer,
  footballManageCompetitionSeasonComparativeStatisticsReducer,
  footballManageSeasonKnockoutListReducer,
  footballManageSeasonKnockoutCreateReducer,
  footballManageSeasonKnockoutEditReducer,
  generalSearchReducer,
  footballSeasonKnockoutListReducer,
  toolbarCompetitionSelectReducer,
  globalSeasonSelectReducer,
  footballManageSeasonMatchPlayerPassStatisticListReducer,
  footballManageSeasonMatchPlayerPassStatisticAddReducer,
  footballManageSeasonMatchPlayerPassStatisticEditReducer,
  footballManageSeasonMatchPlayerPassStatisticDeleteReducer,
  stepperFormReducer,
  footballManageSeasonKnockoutMatchEditReducer,
  fileUploadReducer,
  footballSeasonMatchAddTimeReducer,
  footballSeasonMatchEndReducer,
  footballSeasonMatchStartReducer,
  footballSeasonMatchStateChangeReducer,
  footballManageSeasonMatchPenaltyAddEditDeleteReducer,
  footballManageSeasonMatchPenaltyListReducer,
  footballManageSeasonMatchStatisticReducer,
  footballManagePlayerAttributeListReducer,
  footballManagePlayerAttributeReducer,
  footballManagePlayerAttributeAddEditReducer,
  manageUserReducer,
  manageUserListReducer,
  manageUserEditReducer,
  manageUserAddReducer,
  manageUserAssignAsAdminReducer,
  manageUserUnassignAsAdminReducer,
  profileReducer,
  footballManageTeamManagersReducer,
  footballManageTeamManagerAddReducer,
  footballManageTeamManagerRemoveReducer,
  footballManageTeamCoachesReducer,
  footballManageTeamCoachAddReducer,
  footballManageTeamCoachRemoveReducer,
  profileEditReducer,
  screenResizeReducer,
  footballManageSubTeamActivateReducer,
  footballManageSubTeamAddReducer,
  footballManageSubTeamDeleteReducer,
  footballManageSubTeamEditReducer,
  footballManageSubTeamListReducer,
  footballManageSubTeamReducer,
  footballManageSubTeamTerminateReducer,
  footballManageSubTeamPlayerAddEditReducer,
  footballManageSubTeamPlayerRemoveReducer,
  footballManageSubTeamPlayersAvailableReducer,
  footballManageSubTeamPlayersReducer,
  footballManageHostedCompetitionDetailReducer,
  footballManageHostedCompetitionListReducer,
  footballManageHostedCompetitionAddReducer,
  footballManageHostedCompetitionEditReducer,
  footballManageHostedCompetitionDeleteReducer,
  footballManageSubTeamCoachAddReducer,
  footballManageSubTeamCoachesReducer,
  footballManageSubTeamCoachRemoveReducer,
  footballManageCompetitionManagerReducer,
  footballManageHostedCompetitionManagerReducer,
  fetchedCompetitionReducer,
  footballManageSeasonMatchTeamPlayersReducer,
  footballManageSeasonRefereesReducer,
  footballManageSeasonStadiumsReducer,
  footballManageCompetitionSeasonAvailableTeamsReducer,
  footballManageTeamCompetitionInviteListReducer,
  footballManageTeamCompetitionInviteAcceptRejectReducer,
  footballManageCompetitionSeasonAvailableInviteTeamsReducer,
  footballManageCompetitionSeasonInvitedTeamsReducer,
  footballManageCompetitionSeasonTeamsInviteReducer,
  fetchedTeamReducer,
  footballManageMatchesReducer,
  footballManageTeamUsersAvailableReducer,
  manageFootballOrganizerReducer,
  manageFootballOrganizerAddReducer,
  manageFootballOrganizerDeleteReducer,
  manageFootballOrganizerEditReducer,
  manageFootballOrganizerListReducer,
} from "./slices";
import manageTeamMatchesSlice from "./slices/football/admin/team/manage-team-matches-slice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    profileEdit: profileEditReducer,
    fileUpload: fileUploadReducer,
    generalSearch: generalSearchReducer,
    globalSeasonSelect: globalSeasonSelectReducer,
    imageUpload: imageUploadReducer,
    news: newsReducer,
    pageTitle: pageTitleReducer,
    session: sessionReducer,
    stepperForm: stepperFormReducer,
    toolbarCompetitionSelect: toolbarCompetitionSelectReducer,
    toolbarSearch: toolbarSearchReducer,
    screenResize: screenResizeReducer,
    fetchedCompetition: fetchedCompetitionReducer,
    fetchedTeam: fetchedTeamReducer,
    //public
    //competition
    footballComparativeStatistics: footballComparativeStatisticsReducer,
    footballCompetition: footballCompetitionReducer,
    footballCompetitionTeams: footballCompetitionTeamsReducer,
    footballCompetitionAwards: footballCompetitionAwardsReducer,
    footballCompetitionStats: footballCompetitionStatsReducer,
    //season
    footballSeason: footballSeasonReducer,
    footballSeasonStanding: footballSeasonStandingReducer,
    footballSeasonStatistics: footballSeasonStatisticsReducer,
    footballSeasonKnockoutList: footballSeasonKnockoutListReducer,
    //match
    footballMatchList: footballMatchListReducer,
    footballMatchDetail: footballMatchDetailReducer,
    footballMatchTeams: footballMatchTeamsReducer,
    footballMatchStatistics: footballMatchStatsReducer,
    footballMatchCommentary: footballMatchCommentaryReducer,
    //player
    footballPlayerDetail: footballPlayerReducer,
    footballPlayerAward: footballPlayerAwardReducer,
    footballPlayerTeams: footballPlayerTeamsReducer,
    footballPlayerTraining: footballPlayerTrainingsReducer,
    footballPlayerPositions: footballPlayerPositionsReducer,
    footballPlayerStatistics: footballPlayerStatisticsReducer,
    footballPlayerAttributes: footballPlayerAttributeReducer,
    footballPlayerCompetitions: footballPlayerCompetitionsReducer,
    footballPlayerMatchList: footballPlayerMatchListReducer,
    //team
    footballTeamDetail: footballTeamDetailReducer,
    footballTeamStatistics: footballTeamStatisticsReducer,
    footballTeamPlayers: footballTeamPlayersReducer,
    footballTeamAwards: footballTeamAwardReducer,
    footballTeamCompetitions: footballTeamCompetitionsReducer,
    footballTeamTraining: footballTeamTrainingReducer,
    footballTeamPlayersStatistics: footballTeamPlayersStatisticsReducer,
    //Admin
    //player
    footballManagePlayerList: footballManagePlayerListReducer,
    footballManagePlayer: footballManagePlayerReducer,
    footballManagePlayerAdd: footballManagePlayerAddReducer,
    footballManagePlayerEdit: footballManagePlayerEditReducer,
    footballManagePlayerDelete: footballManagePlayerDeleteReducer,
    footballManagePlayerRetire: footballManagePlayerRetireReducer,
    footballManagePlayerActive: footballManagePlayerActiveReducer,
    footballManagePlayerCompetitions: footballManagePlayerCompetitionsReducer,
    footballManagePlayerStatistics: footballManagePlayerStatisticsReducer,
    footballManagePlayerMatchList: footballManagePlayerMatchListReducer,
    footballManagePlayerAttributeList: footballManagePlayerAttributeListReducer,
    footballManagePlayerAttribute: footballManagePlayerAttributeReducer,
    footballManagePlayerAttributeAddEdit: footballManagePlayerAttributeAddEditReducer,
    ////team
    footballManageTeamList: footballManageTeamListReducer,
    footballManageTeam: footballManageTeamReducer,
    footballManageTeamEdit: footballManageTeamEditReducer,
    footballManageTeamAdd: footballManageTeamAddReducer,
    footballManageTeamDelete: footballManageTeamDeleteReducer,
    footballManageTeamTerminate: footballManageTeamTerminateReducer,
    footballManageTeamActivate: footballManageTeamActivateReducer,
    footballManageTeamUsersAvailable: footballManageTeamUsersAvailableReducer,
    footballManageTeamPlayersAvailable: footballManageTeamPlayersAvailableReducer,
    footballManageTeamPlayers: footballManageTeamPlayersReducer,
    footballManageTeamPlayerAddEdit: footballManageTeamPlayerAddEditReducer,
    footballManageTeamPlayerRemove: footballManageTeamPlayerRemoveReducer,
    footballManageTeamCompetitions: footballManageTeamCompetitionsReducer,
    footballManageTeamStatistics: footballManageTeamStatisticsReducer,
    footballManageTeamManagers: footballManageTeamManagersReducer,
    footballManageTeamManagerAdd: footballManageTeamManagerAddReducer,
    footballManageTeamManagerRemove: footballManageTeamManagerRemoveReducer,
    footballManageTeamCoaches: footballManageTeamCoachesReducer,
    footballManageTeamCoachAdd: footballManageTeamCoachAddReducer,
    footballManageTeamCoachRemove: footballManageTeamCoachRemoveReducer,
    footballManageTeamCompetitionInviteList: footballManageTeamCompetitionInviteListReducer,
    footballManageTeamCompetitionInviteAcceptReject: footballManageTeamCompetitionInviteAcceptRejectReducer,
    //--sub-team
    footballManageSubTeamList: footballManageSubTeamListReducer,
    footballManageSubTeam: footballManageSubTeamReducer,
    footballManageSubTeamEdit: footballManageSubTeamEditReducer,
    footballManageSubTeamAdd: footballManageSubTeamAddReducer,
    footballManageSubTeamDelete: footballManageSubTeamDeleteReducer,
    footballManageSubTeamTerminate: footballManageSubTeamTerminateReducer,
    footballManageSubTeamActivate: footballManageSubTeamActivateReducer,
    footballManageSubTeamPlayersAvailable: footballManageSubTeamPlayersAvailableReducer,
    footballManageSubTeamPlayers: footballManageSubTeamPlayersReducer,
    footballManageSubTeamPlayerAddEdit: footballManageSubTeamPlayerAddEditReducer,
    footballManageSubTeamPlayerRemove: footballManageSubTeamPlayerRemoveReducer,
    footballManageSubTeamCoaches: footballManageSubTeamCoachesReducer,
    footballManageSubTeamCoachAdd: footballManageSubTeamCoachAddReducer,
    footballManageSubTeamCoachRemove: footballManageSubTeamCoachRemoveReducer,
    footballManageHostedCompetitionDetail: footballManageHostedCompetitionDetailReducer,
    footballManageHostedCompetitionList: footballManageHostedCompetitionListReducer,
    footballManageHostedCompetitionAdd: footballManageHostedCompetitionAddReducer,
    footballManageHostedCompetitionEdit: footballManageHostedCompetitionEditReducer,
    footballManageHostedCompetitionRemove: footballManageHostedCompetitionDeleteReducer,
    footballHostedCompetitionManagers: footballManageHostedCompetitionManagerReducer,
    //competition
    footballManageCompetition: footballManageCompetitionReducer,
    footballManageCompetitionList: footballManageCompetitionListReducer,
    footballManageCompetitionEdit: footballManageCompetitionEditReducer,
    footballManageCompetitionAdd: footballManageCompetitionAddReducer,
    footballManageCompetitionDelete: footballManageCompetitionDeleteReducer,
    footballManageCompetitionSeasonTeamList: footballManageCompetitionSeasonTeamListReducer,
    footballManageCompetitionSeasonInvitedTeams: footballManageCompetitionSeasonInvitedTeamsReducer,
    footballManageCompetitionSeasonAvailableTeams: footballManageCompetitionSeasonAvailableTeamsReducer,
    footballManageCompetitionSeasonAvailableInviteTeams: footballManageCompetitionSeasonAvailableInviteTeamsReducer,
    footballManageCompetitionSeasonTeamsInvite: footballManageCompetitionSeasonTeamsInviteReducer,
    footballManageCompetitionSeasonTeamAdd: footballManageCompetitionSeasonTeamAddReducer,
    footballManageCompetitionSeasonTeamRemove: footballManageCompetitionSeasonTeamRemoveReducer,
    footballManageCompetitionSeason: footballManageCompetitionSeasonReducer,
    footballManageCompetitionSeasonStanding: footballManageCompetitionSeasonStandingReducer,
    footballManageCompetitionSeasonComparativeStatistics: footballManageCompetitionSeasonComparativeStatisticsReducer,
    footballManageCompetitionSeasonStatistics: footballManageCompetitionSeasonStatisticsReducer,
    footballManageCompetitionSeasonMatchList: footballManageCompetitionSeasonMatchListReducer,
    footballCompetitionManagers: footballManageCompetitionManagerReducer,
    //organizer
    manageFootballOrganizer: manageFootballOrganizerReducer,
    manageFootballOrganizerList: manageFootballOrganizerListReducer,
    manageFootballOrganizerEdit: manageFootballOrganizerEditReducer,
    manageFootballOrganizerAdd: manageFootballOrganizerAddReducer,
    manageFootballOrganizerDelete: manageFootballOrganizerDeleteReducer,
    //season
    footballManageSeasonAdd: footballManageSeasonAddReducer,
    footballManageSeasonEdit: footballManageSeasonEditReducer,
    footballManageSeasonEnd: footballManageSeasonEndReducer,
    footballManageSeasonReferees: footballManageSeasonRefereesReducer,
    footballManageSeasonStadiums: footballManageSeasonStadiumsReducer,
    //season-teamGroup
    footballManageSeasonTeamGroupAdd: footballManageSeasonTeamGroupAddReducer,
    footballManageSeasonTeamGroupEdit: footballManageSeasonTeamGroupEditReducer,
    footballManageSeasonTeamGroupDelete: footballManageSeasonTeamGroupDeleteReducer,
    footballManageSeasonTeamGroupList: footballManageSeasonTeamGroupListReducer,
    footballManageSeasonTeamGroupTeamAdd: footballManageSeasonTeamGroupTeamAddReducer,
    footballManageSeasonTeamGroupTeamRemove: footballManageSeasonTeamGroupTeamRemoveReducer,
    //season-fixtureGroup
    footballManageSeasonFixtureGroupAdd: footballManageSeasonFixtureGroupAddReducer,
    footballManageSeasonFixtureGroupEdit: footballManageSeasonFixtureGroupEditReducer,
    footballManageSeasonFixtureGroupDelete: footballManageSeasonFixtureGroupDeleteReducer,
    footballManageSeasonFixtureGroups: footballManageSeasonFixtureGroupsReducer,
    footballManageSeasonFixtureGroupFixtures: footballManageSeasonFixtureGroupFixturesReducer,
    footballManageSeasonFixtureGroupFixtureAdd: footballManageSeasonFixtureGroupFixtureAddReducer,
    footballManageSeasonFixtureGroupFixtureEdit: footballManageSeasonFixtureGroupFixtureEditReducer,
    footballManageSeasonFixtureGroupFixtureDelete: footballManageSeasonFixtureGroupFixtureDeleteReducer,
    //season-match
    footballSeasonMatchTime: footballSeasonMatchTimeReducer,
    footballManageSeasonMatchAddTime: footballSeasonMatchAddTimeReducer,
    footballManageSeasonMatchDetail: footballManageSeasonMatchDetailReducer,
    footballManageSeasonMatchEdit: footballManageSeasonMatchEditReducer,
    footballManageSeasonMatchEnd: footballSeasonMatchEndReducer,
    footballManageSeasonMatchStart: footballSeasonMatchStartReducer,
    footballManageSeasonMatchStateChange: footballSeasonMatchStateChangeReducer,
    footballManageSeasonMatchTeamLineup: footballManageSeasonMatchTeamLineupReducer,
    footballManageSeasonMatchTeams: footballManageSeasonMatchTeamsReducer,
    footballManageSeasonMatchTeamPlayers: footballManageSeasonMatchTeamPlayersReducer,
    footballManageSeasonMatchPenaltyAddEditDelete: footballManageSeasonMatchPenaltyAddEditDeleteReducer,
    footballManageSeasonMatchPenaltyList: footballManageSeasonMatchPenaltyListReducer,
    //season-match-commentary
    footballManageSeasonMatchCommentaryList: footballManageSeasonMatchCommentaryListReducer,
    footballManageSeasonMatchCommentaryAdd: footballManageSeasonMatchCommentaryAddReducer,
    footballManageSeasonMatchCommentaryEdit: footballManageSeasonMatchCommentaryEditReducer,
    footballManageSeasonMatchCommentaryDelete: footballManageSeasonMatchCommentaryDeleteReducer,
    //season-match-statistics
    footballManageSeasonMatchPossessionList: footballManageSeasonMatchPossessionListReducer,
    footballManageSeasonMatchPossessionAdd: footballManageSeasonMatchPossessionAddReducer,
    footballManageSeasonMatchPossessionEdit: footballManageSeasonMatchPossessionEditReducer,
    footballManageSeasonMatchPossessionDelete: footballManageSeasonMatchPossessionDeleteReducer,
    footballManageSeasonMatchStatistic: footballManageSeasonMatchStatisticReducer,
    footballManageSeasonMatchPlayersStatisticList: footballManageSeasonMatchPlayersStatisticListReducer,
    footballManageSeasonMatchPlayersStatisticAdd: footballManageSeasonMatchPlayersStatisticAddReducer,
    footballManageSeasonMatchPlayersStatisticEdit: footballManageSeasonMatchPlayersStatisticEditReducer,
    footballManageSeasonMatchPlayersStatisticDelete: footballManageSeasonMatchPlayersStatisticDeleteReducer,
    footballManageSeasonMatchPlayerPassStatisticList: footballManageSeasonMatchPlayerPassStatisticListReducer,
    footballManageSeasonMatchPlayerPassStatisticAdd: footballManageSeasonMatchPlayerPassStatisticAddReducer,
    footballManageSeasonMatchPlayerPassStatisticEdit: footballManageSeasonMatchPlayerPassStatisticEditReducer,
    footballManageSeasonMatchPlayerPassStatisticDelete: footballManageSeasonMatchPlayerPassStatisticDeleteReducer,
    //season-knockout
    footballManageSeasonKnockoutList: footballManageSeasonKnockoutListReducer,
    footballManageSeasonKnockoutCreate: footballManageSeasonKnockoutCreateReducer,
    footballManageSeasonKnockoutEdit: footballManageSeasonKnockoutEditReducer,
    footballManageSeasonKnockoutMatchEdit: footballManageSeasonKnockoutMatchEditReducer,
    //referee
    footballManageRefereeList: footballManageRefereeListReducer,
    footballManageRefereeEdit: footballManageRefereeEditReducer,
    footballManageRefereeAdd: footballManageRefereeAddReducer,
    footballManageRefereeDelete: footballManageRefereeDeleteReducer,
    //stadium
    manageStadium: manageStadiumReducer,
    manageStadiumList: manageStadiumListReducer,
    manageStadiumEdit: manageStadiumEditReducer,
    manageStadiumAdd: manageStadiumAddReducer,
    manageStadiumDelete: manageStadiumDeleteReducer,
    //user
    manageUser: manageUserReducer,
    manageUserList: manageUserListReducer,
    manageUserEdit: manageUserEditReducer,
    manageUserAdd: manageUserAddReducer,
    manageUserAssignAsAdmin: manageUserAssignAsAdminReducer,
    manageUserUnassignAsAdmin: manageUserUnassignAsAdminReducer,
    footballManageTeamMatchListSlice: manageTeamMatchesSlice,
    //dashboard
    footballManageMatches: footballManageMatchesReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({ serializableCheck: false });
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
